const initialState = {
  navOpen: false,
  invertedTheme: false,
  isOnWhitePage: false
};

export default function ui(state = initialState, action) {
  switch (action.type) {
    case 'SET_THEME_INVERTED':
      return {
        ...state,
        invertedTheme: true
      };
    case 'UNSET_THEME_INVERTED':
      return {
        ...state,
        invertedTheme: false
      };
    case 'SET_IS_ON_WHITE_PAGE':
      return {
        ...state,
        isOnWhitePage: true
      };
    case 'UNSET_IS_ON_WHITE_PAGE':
      return {
        ...state,
        isOnWhitePage: false
      };
    case 'TOGGLE_NAV':
      if (!state.navOpen) {
        document.body.classList.add('lock');
      } else {
        document.body.classList.remove('lock');
      }

      return {
        ...state,
        navOpen: !state.navOpen
      };
    case 'CLOSE_NAV':
      return {
        ...state,
        navOpen: false
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/ui.js